import React from "react";
import CTAButton from "../../Buttons/CTAButton/CTAButton";
import MessageImage from '../../../assets/images/dean-image.jpg'

const MessageContentMobile = () => {
  return (
    <div>
      <div className="self-stretch px-2 inline-flex flex-col justify-start items-start gap-2">
        <div className="self-stretch p-2 bg-Color-White shadow-[0px_0px_80px_0px_rgba(0,0,0,0.10)] flex flex-col justify-center items-start gap-8 overflow-hidden">
          <div className="self-stretch inline-flex justify-start items-center gap-2">
            <img className="flex-1 " src={MessageImage}/>
          </div>
          <div className="self-stretch px-2 border-l border-Color-Brand flex flex-col justify-end items-start gap-8">
            <div className="self-stretch justify-start">
              <span class="text-Color-Black text-3xl font-medium font-['Montserrat']">
                Message from the
              </span>
              <span class="text-Color-Black text-2xl font-medium font-['Montserrat']">
                {" "}
              </span>
              <span class="text-Color-Brand text-3xl font-bold font-['Montserrat'] underline">
                Dean
              </span>
            </div>
            <div className="self-stretch justify-start text-Color-Black text-xs font-normal font-['Montserrat'] tracking-tight">
              “Welcome to the Faculty of Engineering, University of Ruhuna. We
              are celebrating the silver jubilee this year, making an
              outstanding 25 years of continuous service to the country in the
              state sector higher education, becoming one of the top-ranking
              engineering faculties in the country.”
            </div>
          </div>
          <CTAButton text="READ MORE" url="https://www.eng.ruh.ac.lk/about/" target="_blank"/>
        </div>
      </div>
    </div>
  );
};

export default MessageContentMobile;
